import React from 'react'
import PropTypes from 'prop-types'
import { Trans } from '@lingui/macro'
import { WarningIcon } from '../../components/common/icons/SvgIcons'

import './ErrorBoundary.scss'


const Description = () => (
  <>
    <p><Trans>Unable to load page.</Trans></p>
    <p>
      <Trans>
        <span>To find out more about Yoti, visit </span>
        <a href="https://www.yoti.com" target="_blank" rel="noopener noreferrer">Yoti</a>
        <span> website.</span>
      </Trans>
    </p>
  </>
)

const ErrorContent = () => (
  <div className="error-page">
    <div className="error-page__container">
      <h1>
        <WarningIcon />
        {' '}
        <Trans>Something went wrong!</Trans>
      </h1>
      <Description />
    </div>
  </div>
)

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidCatch(error, info) {
    this.setState({ error })
  }

  render() {
    const { error } = this.state

    if (error) {
      return <ErrorContent />
    }

    const { children } = this.props
    return children
  }
}

ErrorBoundary.defaultProps = {
  children: null
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element
  ])
}


export default ErrorBoundary
